import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { CheckCircle2, XCircle, Loader2, ArrowLeft } from "lucide-react";
import { api } from "@/lib/api";

export default function PaymentResult({ status }) {
  const [params] = useSearchParams();
  const [state, setState] = useState(status === "success" ? "checking" : "cancel");
  const sessionId = params.get("session_id");

  useEffect(() => {
    if (status !== "success" || !sessionId) return;
    let tries = 0;
    const poll = async () => {
      try {
        const { data } = await api.get(`/payments/status/${sessionId}`);
        if (data.payment_status === "paid") { setState("paid"); return; }
      } catch (e) {}
      if (++tries < 8) setTimeout(poll, 2000); else setState("timeout");
    };
    poll();
  }, [status, sessionId]);

  return (
    <div className="min-h-screen bg-[#0D0D0C] flex items-center justify-center px-6">
      <div className="text-center max-w-md">
        {state === "checking" && (<><Loader2 className="w-14 h-14 text-[#C88D51] animate-spin mx-auto mb-6" /><h1 className="font-serif-d text-3xl mb-3">Vérification du paiement…</h1><p className="font-sub text-[#A39E93]">Un instant, nous confirmons votre acompte.</p></>)}
        {state === "paid" && (<><CheckCircle2 className="w-16 h-16 text-[#C88D51] mx-auto mb-6" /><h1 className="font-serif-d text-4xl mb-3">Réservation confirmée ✦</h1><p className="font-sub text-[#A39E93] mb-8">Merci ! Votre acompte de 150€ a bien été reçu. Éléonore vous contactera très vite pour préparer la séance.</p></>)}
        {(state === "cancel" || state === "timeout") && (<><XCircle className="w-16 h-16 text-[#A39E93] mx-auto mb-6" /><h1 className="font-serif-d text-4xl mb-3">{state === "cancel" ? "Paiement annulé" : "En attente"}</h1><p className="font-sub text-[#A39E93] mb-8">{state === "cancel" ? "Aucun montant n'a été débité. Vous pouvez réessayer quand vous le souhaitez." : "Le paiement n'est pas encore confirmé. Vérifiez vos emails ou réessayez."}</p></>)}
        <Link to="/" data-testid="back-home" className="btn-ghost inline-flex items-center gap-2 px-6 py-3 font-sub text-sm"><ArrowLeft className="w-4 h-4" /> Retour à l'accueil</Link>
      </div>
    </div>
  );
}
